define('helperMisc-replaceTextholder',[],function() {
    'use strict';

    function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }

    return function(training, user, text) {
        var tvm = training,
            uvm = user,
            replacementMap = {},
            re = "";

        if (text) {

            if (text.indexOf("[[") > -1) {

                if (tvm && typeof(tvm.quizCorrectTasks) === 'function') {
                    // Training specific placeholders
                    replacementMap['***pts***'] = tvm.quizCorrectTasks(); // legacy format, just in case
                    replacementMap['[[QUIZ_POINTS]]'] = tvm.quizCorrectTasks();
                    replacementMap['[[QUIZ_TOTAL]]'] = tvm.quizTotal();
                    replacementMap['[[QUIZ_TASK_INDEX]]'] = tvm.quizPage();
                    replacementMap['[[LAST_QUIZ_POINTS]]'] = tvm.lastQuizProgress().correctTasks;
                    replacementMap['[[LAST_QUIZ_TOTAL]]'] = tvm.lastQuizProgress().totalTasks;
                }

                if (uvm) {
                    // User specific placeholders
                    replacementMap['[[USER_FULL_NAME]]'] = uvm.fullName();
                    replacementMap['[[USER_FIRST_NAME]]'] = uvm.firstName();
                    replacementMap['[[USER_LAST_NAME]]'] = uvm.lastName();
                    replacementMap['[[USER_EMAIL]]'] = uvm.email();
                }

                for (var item in replacementMap) {
                    re += escapeRegExp(item) + "|";
                }
                re = re.slice(0, -1);

                text = text.replace(new RegExp(re, "gi"), function (matched) {
                    return replacementMap[matched];
                });
            }

            return text;
        }

    }
});

